import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/new-design/images/request-tenant.png'


const _withScopeId = n => (_pushScopeId("data-v-0f0be69c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "request-tenant-reference-container w-100" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-header w-100 flex-column d-flex" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "Request Tenant Reference"),
  /*#__PURE__*/_createElementVNode("p", { class: "sub-title" }, " Please enter tenant & agent details below for a Rental Reference ")
], -1))
const _hoisted_3 = { class: "section-form w-100" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, "Agency Details", -1))
const _hoisted_5 = { class: "row w-100" }
const _hoisted_6 = { class: "col-lg-9" }
const _hoisted_7 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Business Name")
], -1))
const _hoisted_9 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_10 = { class: "section-form w-100" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, "Property Manager", -1))
const _hoisted_12 = { class: "row w-100" }
const _hoisted_13 = { class: "col-lg-4" }
const _hoisted_14 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Full Name")
], -1))
const _hoisted_16 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_17 = { class: "col-lg-4" }
const _hoisted_18 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Mobile Number")
], -1))
const _hoisted_20 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_21 = { class: "col-lg-4" }
const _hoisted_22 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Email")
], -1))
const _hoisted_24 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_25 = { class: "section-form w-100" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, "Tenant Details", -1))
const _hoisted_27 = { class: "row w-100" }
const _hoisted_28 = { class: "col-lg-4" }
const _hoisted_29 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "First Name")
], -1))
const _hoisted_31 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_32 = { class: "col-lg-4" }
const _hoisted_33 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Surname")
], -1))
const _hoisted_35 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_36 = { class: "col-lg-4" }
const _hoisted_37 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Date of Birth")
], -1))
const _hoisted_39 = { class: "section-form w-100" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, "Property Details", -1))
const _hoisted_41 = { class: "row w-100" }
const _hoisted_42 = { class: "col-lg-6" }
const _hoisted_43 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Address")
], -1))
const _hoisted_45 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_46 = { class: "col-lg-6" }
const _hoisted_47 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Suburb")
], -1))
const _hoisted_49 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_50 = { class: "col-lg-4" }
const _hoisted_51 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "State")
], -1))
const _hoisted_53 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_54 = { class: "col-lg-4" }
const _hoisted_55 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Post Code")
], -1))
const _hoisted_57 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_58 = { class: "col-lg-4" }
const _hoisted_59 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Country")
], -1))
const _hoisted_61 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_62 = { class: "section-action d-flex w-100 align-items-center justify-content-between" }
const _hoisted_63 = ["disabled", "data-kt-indicator"]
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Submit ", -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Submitting... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_66 = [
  _hoisted_64,
  _hoisted_65
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navigator = _resolveComponent("Navigator")!
  const _component_FormField = _resolveComponent("FormField")!
  const _component_States = _resolveComponent("States")!
  const _component_Countries = _resolveComponent("Countries")!
  const _directive_mask = _resolveDirective("mask")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Navigator, { text: "Back to dashboard" }),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("form", {
        ref: "form",
        onSubmit: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
      }, [
        _createElementVNode("section", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.agency_name) = $event)),
                  type: "text",
                  class: _normalizeClass(["form-control", { 'is-invalid': _ctx.v$.form.agency_name.$errors.length }])
                }, null, 2), [
                  [_vModelText, _ctx.form.agency_name]
                ]),
                (_ctx.v$.form.agency_name.$errors.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.v$.form.agency_name.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createElementVNode("section", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.property_manager_name) = $event)),
                  type: "text",
                  class: _normalizeClass(["form-control", {
                    'is-invalid': _ctx.v$.form.property_manager_name.$errors.length,
                  }])
                }, null, 2), [
                  [_vModelText, _ctx.form.property_manager_name]
                ]),
                (_ctx.v$.form.property_manager_name.$errors.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.v$.form.property_manager_name.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.property_manager_mobile) = $event)),
                  type: "text",
                  class: _normalizeClass(["form-control", {
                    'is-invalid':
                      _ctx.v$.form.property_manager_mobile.$errors.length,
                  }])
                }, null, 2), [
                  [_vModelText, _ctx.form.property_manager_mobile],
                  [_directive_mask, _ctx.maskMobile]
                ]),
                (_ctx.v$.form.property_manager_mobile.$errors.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.v$.form.property_manager_mobile.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.property_manager_email) = $event)),
                  type: "text",
                  class: _normalizeClass(["form-control", {
                    'is-invalid': _ctx.v$.form.property_manager_email.$errors.length,
                  }])
                }, null, 2), [
                  [_vModelText, _ctx.form.property_manager_email]
                ]),
                (_ctx.v$.form.property_manager_email.$errors.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.v$.form.property_manager_email.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createElementVNode("section", _hoisted_25, [
          _hoisted_26,
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _hoisted_30,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.first_name) = $event)),
                  type: "text",
                  class: _normalizeClass(["form-control", { 'is-invalid': _ctx.v$.form.first_name.$errors.length }])
                }, null, 2), [
                  [_vModelText, _ctx.form.first_name]
                ]),
                (_ctx.v$.form.first_name.$errors.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(_ctx.v$.form.first_name.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _hoisted_34,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.last_name) = $event)),
                  type: "text",
                  class: _normalizeClass(["form-control", { 'is-invalid': _ctx.v$.form.last_name.$errors.length }])
                }, null, 2), [
                  [_vModelText, _ctx.form.last_name]
                ]),
                (_ctx.v$.form.last_name.$errors.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(_ctx.v$.form.last_name.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _hoisted_38,
                _createVNode(_component_FormField, {
                  value: _ctx.form.date_of_birth,
                  required: false,
                  name: "date_of_birth",
                  containerClass: "w-100",
                  label: "Date of Birth",
                  placeholder: "Pick a date",
                  type: "datepicker",
                  showLabel: false,
                  style: {"margin-bottom":"0px !important"}
                }, null, 8, ["value"])
              ])
            ])
          ])
        ]),
        _createElementVNode("section", _hoisted_39, [
          _hoisted_40,
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _hoisted_44,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.address_line) = $event)),
                  type: "text",
                  class: _normalizeClass(["form-control", { 'is-invalid': _ctx.v$.form.address_line.$errors.length }])
                }, null, 2), [
                  [_vModelText, _ctx.form.address_line]
                ]),
                (_ctx.v$.form.address_line.$errors.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_45, _toDisplayString(_ctx.v$.form.address_line.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _hoisted_48,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.city) = $event)),
                  type: "text",
                  class: _normalizeClass(["form-control", { 'is-invalid': _ctx.v$.form.city.$errors.length }])
                }, null, 2), [
                  [_vModelText, _ctx.form.city]
                ]),
                (_ctx.v$.form.city.$errors.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_49, _toDisplayString(_ctx.v$.form.city.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("div", _hoisted_51, [
                _hoisted_52,
                _createVNode(_component_States, {
                  options: _ctx.states,
                  value: _ctx.form.state,
                  containerClass: "flex-fill w-100 mb-0",
                  onChange: _ctx.handleStateSelect,
                  name: "state",
                  "show-label": false,
                  style: {"margin-bottom":"0px !important"},
                  class: _normalizeClass({ 'is-invalid': _ctx.v$.form.state.$errors.length })
                }, null, 8, ["options", "value", "onChange", "class"]),
                (_ctx.v$.form.state.$errors.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_53, _toDisplayString(_ctx.v$.form.state.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("div", _hoisted_55, [
                _hoisted_56,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.post_code) = $event)),
                  type: "text",
                  class: _normalizeClass(["form-control", { 'is-invalid': _ctx.v$.form.post_code.$errors.length }])
                }, null, 2), [
                  [_vModelText, _ctx.form.post_code],
                  [_directive_mask, _ctx.maskPostCode]
                ]),
                (_ctx.v$.form.post_code.$errors.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_57, _toDisplayString(_ctx.v$.form.post_code.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("div", _hoisted_59, [
                _hoisted_60,
                _createVNode(_component_Countries, {
                  value: _ctx.form.country,
                  containerClass: "flex-fill w-100 mb-0",
                  name: "country",
                  "show-label": false,
                  style: {"margin-bottom":"0px !important"},
                  onChange: _ctx.handleCountrySelect,
                  class: _normalizeClass({ 'is-invalid': _ctx.v$.form.country.$errors.length })
                }, null, 8, ["value", "onChange", "class"]),
                (_ctx.v$.form.country.$errors.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_61, _toDisplayString(_ctx.v$.form.country.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_62, [
          _createElementVNode("button", {
            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args))),
            class: "btn btn-new-design-secondary"
          }, " Reset "),
          _createElementVNode("button", {
            disabled: _ctx.loading,
            type: "submit",
            onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args))),
            class: "btn btn-new-design-primary",
            "data-kt-indicator": _ctx.loading ? 'on' : null
          }, _hoisted_66, 8, _hoisted_63)
        ])
      ], 544)
    ])
  ]))
}